import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Form, Section } from 'features/order-tracker/shared-components';
import { CloseIcon } from 'features/order-tracker/shared-components/svg';
import { closeOTPopUp } from 'features/order-tracker/store/actions';
import { toggleMainWindowScroll } from 'features/order-tracker/utils';

import { FORM_TITLE, KEY_ENTER } from './constants';

import styles from './styles.module.scss';

export const OrderTrackerPopUpForm: React.FC<components.OrderTrackerPopUpForm> = ({
  initOrderSummaryPageFlow,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isInitialMount = useRef(true);

  const closeOTPopUpHandler = (): void => {
    dispatch(closeOTPopUp());
    toggleMainWindowScroll();
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    initOrderSummaryPageFlow();
  }, [location]);

  const onKeyDownHandler = ({ key }: React.KeyboardEvent): void => {
    if (key === KEY_ENTER) {
      closeOTPopUpHandler();
    }
  };

  return (
    <div className={styles.popUpLayout}>
      <div className={styles.popUpContainer}>
        <Section className={styles.popUpSection} bgColor="white">
          <h3>{FORM_TITLE}</h3>
          <Form />
        </Section>
        <button
          className={styles.closeButton}
          onClick={closeOTPopUpHandler}
          onKeyDown={onKeyDownHandler}
          type="button"
        >
          <CloseIcon height={32} width={32} />
        </button>
      </div>
    </div>
  );
};
